import React from 'react';
import ModuleCard from 'components/module-card/ModuleCard';
import history from 'services/history';
import { PaymentMethod } from 'types/paymentMethod';

type PaymentMethodItemModuleProps = {
  paymentMethod: PaymentMethod;
  handleSearch: () => void;
};

const PaymentMethodItemModule: React.FC<PaymentMethodItemModuleProps> = ({ paymentMethod }) => {
  return (
    <ModuleCard
      idLabel={`ID ${paymentMethod.id}`}
      title={paymentMethod.name}
      subtitle="Método de pagamento"
      fields={[
        { label: 'Tipo', value: paymentMethod.type },
        { label: 'Max. parcelas', value: paymentMethod.max_installments },
      ]}
      onClick={() => history.push(`/payment-methods/${paymentMethod.id}`)}
    />
  );
};

export default PaymentMethodItemModule;
